//
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import Tabby from 'tabbyjs/dist/js/tabby.min';

export default class Tabs extends WebComponent {
	didMount() {
		const isPopularCategories = this.element.classList.contains('tabs__popular-categories');
		const isTopProducts = this.element.classList.contains('tabs__top-products');

		if (isPopularCategories) {
        	this.popularCategoriesTabs = new Tabby('.tabs__popular-categories');
		} else if (isTopProducts) {
        	this.topProductsTabs = new Tabby('.tabs__top-products');
		} else {
        	this.tabs = new Tabby('.tabs__list');
		}

	}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Tabs.js